export interface NPCPosition {
  id: string;
  nameKey: string;
  position: {
    lat: number;
    lng: number;
  };
  image?: string;
  npcCategory?: string;
}

export const MARKERS_NPCS: NPCPosition[] = [
  {
    id: "bob",
    nameKey: "npcs.bob",
    position: { lat: -468, lng: 501.5 },
    image: "/map/bob.webp",
    npcCategory: "shop",
  },
  {
    id: "atara",
    nameKey: "npcs.atara",
    position: { lat: -525.125, lng: 495.25 },
    image: "/map/atara.webp",
    npcCategory: "event",
  },
  {
    id: "collector",
    nameKey: "npcs.collector",
    position: { lat: -482, lng: 466 },
    image: "/map/collector.webp",
    npcCategory: "shop",
  },
  {
    id: "dorothee",
    nameKey: "npcs.dorothee",
    position: { lat: -470.5, lng: 489.5 },
    image: "/map/dorothee.webp",
    npcCategory: "shop",
  },
  {
    id: "massimo",
    nameKey: "npcs.massimo",
    position: { lat: -441.875, lng: 485.75 },
    image: "/map/massimo.webp",
    npcCategory: "mentor",
  },
  {
    id: "ka-ching",
    nameKey: "npcs.kaChing",
    position: { lat: -414.000541, lng: 418.496334 },
    image: "/map/ka-ching.webp",
    npcCategory: "shop",
  },
  {
    id: "andrew",
    nameKey: "npcs.andrew",
    position: { lat: -400, lng: 590.25 },
    image: "/map/andrew.webp",
    npcCategory: "special",
  },
  {
    id: "eric",
    nameKey: "npcs.eric",
    position: { lat: -257.25, lng: 514.5 },
    image: "/map/eric.webp",
    npcCategory: "other",
  },
  {
    id: "vanya",
    nameKey: "npcs.vanya",
    position: { lat: -453.75, lng: 548.25 },
    image: "/map/vanya.webp",
    npcCategory: "mentor",
  },
  {
    id: "naniwa",
    nameKey: "npcs.naniwa",
    position: { lat: -504, lng: 592 },
    image: "/map/naniwa.webp",
    npcCategory: "mentor",
  },
  {
    id: "mrs-joan",
    nameKey: "npcs.mrsJoan",
    position: { lat: -498.75, lng: 523.5 },
    image: "/map/mrs-joan.webp",
    npcCategory: "mentor",
  },
  {
    id: "will",
    nameKey: "npcs.will",
    position: { lat: -797.498216, lng: 419.50271 },
    image: "/map/will.webp",
    npcCategory: "other",
  },
  {
    id: "patti",
    nameKey: "npcs.patti",
    position: { lat: -355, lng: 827 },
    image: "/map/patty.webp",
    npcCategory: "other",
  },
  {
    id: "vernie",
    nameKey: "npcs.vernie",
    position: { lat: -658, lng: 213 },
    image: "/map/vernie.webp",
    npcCategory: "other",
  },
  {
    id: "annie",
    nameKey: "npcs.annie",
    position: { lat: -497.5, lng: 490.5 },
    image: "/map/annie.webp",
    npcCategory: "shop",
  },
  {
    id: "bailey-j",
    nameKey: "npcs.baileyJ",
    position: { lat: -500.25, lng: 529.75 },
    image: "/map/bailey-j.webp",
    npcCategory: "mentor",
  },
  {
    id: "bill",
    nameKey: "npcs.bill",
    position: { lat: -730.498864, lng: 445.004145 },
    image: "/map/bill.webp",
    npcCategory: "event",
  },
  {
    id: "doris",
    nameKey: "npcs.doris",
    position: { lat: -508, lng: 412 },
    image: "/map/doris.webp",
    npcCategory: "special",
  },
  {
    id: "blanc",
    nameKey: "npcs.blanc",
    position: { lat: -535, lng: 568.25 },
    image: "/map/blanc.webp",
    npcCategory: "mentor",
  },
  {
    id: "azure",
    nameKey: "npcs.azure",
    position: { lat: -176.75, lng: 455.75 },
    image: "/map/azure.webp",
    npcCategory: "other",
  },
];
